import usePlaceRelevance from './placeRelevance';

// תגית "לא מגיע ל..." בכרטיסי העסקים - לפי העיר של הלקוח בפועל (myCity). הכלל ב-placeRelevance.js.
// מחזיר פונקציה: item -> טקסט התגית, או "".
const useNotDelivering = () => usePlaceRelevance().notDeliveringTxt;

export default useNotDelivering;
